import { baseApi } from './baseApi';
import { toastSlice } from './common/toast/slice';

export const appReducer = {
  [baseApi.reducerPath]: baseApi.reducer,
  [toastSlice.reducerPath]: toastSlice.reducer,
};
